<template>
    <nav>
      <component :is="navType">
        <template slot="pre-nav">
          <li>
            <router-link :to="{ 'name': 'dashboard' }">Dashboard</router-link>
          </li>
        </template>
        <template slot="post-nav">
          <li>
            <router-link :to="{ 'name': 'company-library' }">Document Library</router-link>
          </li>
        </template>
      </component>
    </nav>
</template>

<script>
import { mapGetters } from 'vuex'

import FactoringNav from './FactoringNav'
import ShipperNav from './ShipperNav'
import TrucklAdminNav from './TrucklAdminNav'
import CarrierNav from './CarrierNav'

export default {
  name: 'MainNavigation',

  computed: {
    ...mapGetters('user', ['isFactoring', 'isShipper', 'isTrucklAdmin', 'isCarrier']),

    navType() {
      if (this.isFactoring) {
        return 'factoring-nav'
      } else if (this.isShipper) {
        return 'shipper-nav'
      } else if (this.isTrucklAdmin) {
        return 'truckl-admin-nav'
      } else if (this.isCarrier) {
        return 'carrier-nav'
      }
    }
  },

  components: {
    FactoringNav,
    ShipperNav,
    TrucklAdminNav,
    CarrierNav
  }
}
</script>

<style scoped lang="scss">
@import 'styles.scss';
</style>
